/**
 * Anchor Links
 *
 * Handle anchor link behavior and scroll offset adjustments.
 */

document.addEventListener( 'DOMContentLoaded', () => {
	/**
	 * Make sure anchor tags with just a # as href attribute value is disabled.
	 *
	 * not cmplz-link is to make sure the Complianz doc links works,
	 * since they are replaced by javascript and therefore still
	 * has a href of # in source
	 */
	const emptyAnchors = document.querySelectorAll( 'a[href="#"]:not(.cmplz-link)' );
	emptyAnchors.forEach( anchor => {
		anchor.addEventListener( 'click', e => {
			// Check if it is still '#' by the time this is executed.
			if ( '#' !== e.currentTarget.getAttribute( 'href' ) ) {
				return;
			}

			e.preventDefault();
		} );
	} );

	/**
	 * Trigger the scrollOffset function on inpage anchor links.
	 */
	const anchorLinks = document.querySelectorAll( 'a[href^="#"]:not([href="#"])' );
	anchorLinks.forEach( anchor => {
		anchor.addEventListener( 'click', e => {
			const href = anchor.getAttribute( 'href' );
			const target = document.querySelector( href );

			// Bail if we can't find the target on this page.
			if ( ! target ) {
				return;
			}

			// Prevent default behaviour
			e.preventDefault();

			// Add the anchor link to the URL without triggering any scrolls.
			window.history.replaceState( {}, '', href );

			// Call the function and request animation!
			handleScrollOffset( target, true );
		} );
	} );

	/**
	 * Trigger custom location scroll on page load.
	 */
	if ( window.location.hash ) {
		handleOnloadScroll( window.location.hash );
	}

	/**
	 * Handle scroll position on page load with a hash.
	 *
	 * @param {string} hash the url hash which should correspond to the ID of an element.
	 */
	function handleOnloadScroll( hash ) {
		const target = document.querySelector( hash );

		// Bail if we can't find the target on this page.
		if ( ! target ) {
			return;
		}

		// Delay this by just a millisecond and we hit our actual target.
		// This is a hack to get the position right after the browsers own scroll.
		setTimeout( () => {
			handleScrollOffset( target );
		}, 1 );
	}

	/**
	 * Make sure we offset the scroll position by the headers height.
	 *
	 * @param {HTMLElement} target  the target element.
	 * @param {boolean}     animate whether to animate the scroll or not.
	 */
	function handleScrollOffset( target, animate = false ) {
		// Get standard offset.
		let offTop = target.getBoundingClientRect().top + window.pageYOffset;

		// Check if menu is sticky
		const menu = document.querySelector( '.site-header' );
		const menuNavigation = menu?.querySelector( '.main-navigation' );
		if ( menu ) {
			const menuStyles = window.getComputedStyle( menu );
			const isSticky = menu.classList.contains( 'is-sticky' ) ||
			menuStyles.position === 'sticky' ||
			menuStyles.position === 'fixed';

			if ( isSticky ) {
				// Calculate offset with menu height.
				offTop -= menuNavigation.offsetHeight;
			}
		}

		// Animate to the scroll position if requested.
		if ( animate ) {
			window.scrollTo( {
				top: offTop,
				behavior: 'smooth',
			} );
			return;
		}

		// Move the scroll position in place without animation!
		window.scrollTo( 0, offTop );
	}
} );
